export default {
    approvalFlow: {
        cooperative: {
            delete: 'Excluir Cooperativa',
            deactivate: 'Desativar Cooperativa',
            activate: 'Ativar Cooperativa',
            add: 'Adicionar Nova Cooperativa',
            edit: 'Editar Cooperativa',
            cooperativeName: 'Nome da Cooperativa',
            cooperativeNameTT: 'O nome legalmente registrado da cooperativa, usado em todos os registros de conformidade e relatórios.',
            membershipPlan: 'Plano de Associação',
            membershipPlanTT: 'O plano ou acordo que descreve os termos e condições da associação na cooperativa.',
            primaryContact: 'Contato Principal',
            primaryContactTT: 'Nome do contato, email, telefone.',
            firstName: 'Nome',
            lastName: 'Sobrenome',
            phoneNumber: 'Número de Telefone',
            email: 'Email',
            location: 'Localização',
            locationTT: 'Filtrar por texto de localização (país/província/cidade).',
            country: 'País',
            countryTT: 'O país onde a cooperativa está legalmente registrada e opera. Isso ajuda a alinhar relatórios com regulamentações nacionais.',
            provinceState: 'Província/Estado',
            provinceStateTT: 'A província ou estado onde a cooperativa está legalmente registrada e opera. Isso ajuda a alinhar relatórios com regulamentações regionais.',
            regionDistrict: 'Região/Distrito',
            regionDistrictTT: 'A região ou distrito onde a cooperativa está baseada. Isso ajuda a garantir identificação precisa no nível da comunidade.',
            villageTownCity: 'Vila/Cidade',
            villageTownCityTT: 'O nome do assentamento local (vila, cidade ou cidade) onde a cooperativa está baseada. Isso garante identificação precisa no nível da comunidade.',
            address: 'Endereço',
            addressTT: 'O endereço físico ou postal completo da cooperativa. Deve incluir detalhes da rua, se disponível, para referência precisa em relatórios.',
            businessInformation: 'Informações Comerciais',
            interestedCommodities: 'Commodities/Produtos de Interesse',
            interestedCommoditiesTT: 'Exibe o código e nome do produto associado ao relatório. Este campo ajuda os usuários a entender qual produto o relatório está relacionado.',
            coffee: 'Café',
            cacao: 'Cacau',
            landRegistered: 'Quanta terra será registrada? (em hectares)',
            userType: 'Tipo de Usuário',
            userTypeTT: 'Filtrar resultados por função/tipo da Cooperativa.',
            exporter: 'Exportador',
            cooperative: 'Cooperativa',
            bothOfThem: 'Ambos',
            uploadLogo: 'Fazer upload da cópia do Logo',
            uploadLogoButton: 'FAZER UPLOAD DO LOGO',
            enterHere: 'Digite aqui',
            select: 'Selecionar',
            cooperativeNameRequired: 'Nome da cooperativa é obrigatório',
            firstNameRequired: 'Nome é obrigatório',
            emailRequired: 'Email é obrigatório',
            invalidEmail: 'Email inválido',
            required: 'Obrigatório',
            pleaseUploadValidImage: 'Por favor, faça upload de um arquivo de imagem válido',
            errorPreparingData: 'Erro ao preparar dados',
            cancel: 'Cancelar',
            save: 'Salvar',
            update: 'Atualizar',

            // List page translations
            listOfCooperatives: 'Lista de Cooperativas',
            addCooperatives: 'Adicionar Cooperativas',
            loadingData: 'Carregando dados...',
            search: 'Pesquisar',
            type: 'Tipo',
            cooperativeTypeInformation: 'Informações do Tipo de Cooperativa',
            all: 'Todos',
            of: 'de',
            active: 'Ativo',
            unregistered: 'Não Registrado',
            deactivated: 'Desativado',
            view: 'Ver',
            confirmDelete: 'Confirmar Exclusão',
            areYouSureDeleteCooperative: 'Tem certeza de que deseja excluir esta cooperativa?',
            updatedSuccessfully: 'Atualizado com sucesso',
            createdSuccessfully: 'Criado com sucesso',
            errorFetchingCooperativeDetails: 'Erro ao buscar detalhes da cooperativa',
            errorSavingCooperative: 'Erro ao salvar cooperativa',
            errorFetchingCooperativesData: 'Erro ao buscar dados das cooperativas',
            cooperativeDeactivatedSuccessfully: 'Cooperativa desativada com sucesso',
            errorDeactivatingCooperative: 'Erro ao desativar cooperativa',
            cooperativeDeletedSuccessfully: 'Cooperativa excluída com sucesso',
            errorDeletingCooperative: 'Erro ao excluir cooperativa',
            // Table headers
            noOfFarms: 'No. de Fazendas',
            cropsProducts: 'Cultivos/Produtos',
            status: 'Status',
            statusTT: 'Status operacional da cooperativa no sistema (ex: Ativo, Desativado, Não Registrado).',
            actions: 'Ações',
            // Cooperative types
            cooperativeAndExporter: 'Cooperativa + Exportador',
            // Success messages
            cooperativeActivatedSuccessfully: 'Cooperativa ativada com sucesso',
            back: 'Voltar',
            commoditiesProducts: 'Detail Cooperativa',
            cooperativeEmail: 'Email Cooperativa',
            cooperativePhoneNumber: 'Número de Telefone Cooperativa',
            logo: 'Logo',
            logoTT: 'Imagem oficial ou símbolo do logo da Organização para branding em relatórios/páginas QR.',
            advanced: 'Avançado',
        },
    },
};
